// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28tts","label":"styles_label__2Pfls"};